var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","outlined":"","rounded":"","small":"","color":"primary"},on:{"click":function($event){return _vm.changeLoginDialogState(true,false)}}},[_vm._v("تسجيل الدخول ")])}
var staticRenderFns = []

export { render, staticRenderFns }